
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/markets-overview",
      function () {
        return require("private-next-pages/markets-overview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/markets-overview"])
      });
    }
  